import { AppByAnima } from "./sections/AppByAnima";
import { CtaByAnima } from "./sections/CtaByAnima";
import { FooterByAnima } from "./sections/FooterByAnima";
// import { FrameByAnima } from "./sections/FrameByAnima/FrameByAnima";
import { HeroByAnima } from "./sections/HeroByAnima";
import { IntegrationByAnima } from "./sections/IntegrationByAnima";
import { FeaturesByAnima } from "./sections/FeaturesByAnima";
import { StatsByAnima } from "./sections/StatsByAnima";
import { ProcessByAnima } from "./sections/ProcessByAnima";
import { Partners } from "./sections/ParntersSection/partners";
import { TestimonialsByAnima } from "./sections/TestimonialsByAnima";
// import  OverlayMessage  from "./sections/OverlayMessage"; // Import the overlay component
import { FrameByAnima } from "./sections/FrameByAnima/FrameByAnima";

export const LandingPage = (): JSX.Element => {
  return (
    <div className="relative"> {/* Add relative positioning to create stacking context */}
      {/* Overlay message will appear on top of all content */}
        {/* <OverlayMessage /> */}
      
      
      {/* Your existing content */}
      <div className="flex flex-col items-center bg-white overflow-x-hidden w-full min-h-screen overflow-y-auto">
        {/* Header */}

        <main className="flex flex-col w-full z-10">
          <section id="hero mt-12 sm:mt-0">
            <HeroByAnima />
          </section>

          <section id="feature-section" className="w-full">
            <FeaturesByAnima />
          </section>

          <Partners />

          <section className="w-full">
            <FrameByAnima />
          </section>

          <section className="w-full"  >
            <StatsByAnima />
          </section>

          <section className="w-full">
            <AppByAnima />
          </section>

          <section className="w-full" id="how-it-works">
            <ProcessByAnima />
          </section>

          <section className="w-full">
            <IntegrationByAnima />
          </section>

          <section id="testimonials" className="w-full">
            <TestimonialsByAnima />
          </section>

          <section className="w-full">
            <CtaByAnima />
          </section>
        </main>

        <FooterByAnima />
      </div>
    </div>
  );
};